import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import VerifyContactInfoWrapper from './VerifyContactInfoWrapper';
import * as SecurityHelper from '../../../helpers/securityHelper';

export default class InternalVerifyContactInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            account: null,
            verifiedAddress: null,
            done: false,
            showNotice: false,
            noticeType: 'error',
            noticeText: ''
        }

        this.getAccount = this.getAccount.bind(this);
        this.verificationRequired = this.verificationRequired.bind(this);
        this.verifyAddress = this.verifyAddress.bind(this);
        this.saveProfile = this.saveProfile.bind(this);
    }

    async getAccount(accountID) {
        try {
            const url = `${process.env.API}/accounts/internal/search?email=${accountID}`;
            const response = await axios.get(url, { headers: { Authorization: SecurityHelper.getInternalAuthHeader() } });
            this.setState({
                account: response.data.account
            });
        }
        catch (error) {
            this.setState({
                showNotice: true,
                noticeType: 'error',
                noticeText: 'We were unable to load the Account associated with this order. Please try again later.'
            })
        }
    }

    async verificationRequired() {
        try {
            const url = `${process.env.API}/orders/internal/orders/${this.props.orderID}/verification`;
            const response = await axios.get(url, { headers: { Authorization: SecurityHelper.getInternalAuthHeader() } });
            if (!response.data.address_verification_required) {
                this.setState({
                    showNotice: false,
                    done: true
                }, this.props.callback);
            }
            else {
                this.getAccount(response.data.account_id);
            }
        }
        catch (error) {
            this.setState({
                showNotice: true,
                noticeType: 'error',
                noticeText: 'We were unable to determine whether or not this Order requires Address Verification.  Please try again later.'
            })
        }
    }

    async verifyAddress() {
        try {
            const url = `${process.env.API}/accounts/internal/address/verify`;
            const response = await axios.post(url, this.state.account.home_address, { headers: { Authorization: SecurityHelper.getInternalAuthHeader() } });
            this.setState({
                showNotice: false,
                verifiedAddress: response.data,
                done: false
            });
        }
        catch (error) {
            this.setState({
                verifiedAddress: null,
                showNotice: true,
                noticeType: 'error',
                noticeText: 'An error occurred trying to verify this address. Please ensure you have a Street Address, as well as a City+State or ZIP before proceeding.',
                done: false
            });
        }
    }

    async saveProfile(updatedAccount) {
        try {
            const url = `${process.env.API}/accounts/internal/orders/${this.props.orderID}/address`;
            await axios.post(url, updatedAccount, { headers: { Authorization: SecurityHelper.getInternalAuthHeader() } });
            this.setState({
                showNotice: false,
                done: true
            }, this.props.callback);
        }
        catch (error) {
            this.setState({
                verifiedAddress: null,
                showNotice: true,
                noticeType: 'error',
                noticeText: 'An error occurred trying to Update this Address.',
                done: false
            });
        }
    }

    render() {
        return (
            <div className="rec-verify-contact-info-wrapper">
                <VerifyContactInfoWrapper
                    account={this.state.account}
                    orderID={this.props.orderID}
                    saveProfile={this.saveProfile}
                    verifyAddress={this.verifyAddress}
                    verificationRequired={this.verificationRequired}
                    verifiedAddress={this.state.verifiedAddress}
                    showNotice={this.state.showNotice}
                    noticeType={this.state.noticeType}
                    noticeText={this.state.noticeText}
                    done={this.state.done} />
            </div>
        );
    }
}

InternalVerifyContactInfo.propTypes = {
    orderID: PropTypes.string.isRequired,
    callback: PropTypes.func
};
